export const categoryOptions = [
	{ value: 'Announcement', label: 'Announcement' },
	{ value: 'Inspiration', label: 'Inspiration' },
	{ value: 'Achievement', label: 'Achievement' },
	{ value: 'Activity', label: 'Activity' },
	{ value: 'Photo Update', label: 'Photo Update' },
	{ value: 'Devotional', label: 'Devotional' },
	{ value: 'Awareness', label: 'Awareness' },
	// { value: "other", label: "Other" },
]

export const designationOptions = [
	{ value: 'president', label: 'President' },
	{ value: 'vice president', label: 'Vice President' },
	{ value: 'secratary', label: 'Secratary' },
	{ value: 'joint secretary', label: 'Joint secretary' },
	{ value: 'treasrer', label: 'Treasrer' },
	{ value: 'joint Treasrer', label: 'Joint Treasrer' },
	{ value: 'managing committee member ', label: 'Managing committee Member' },
	{ value: 'managing trustee', label: 'Managing Trustee' },
	{ value: 'trustee-secratary', label: 'Trustee-Secratary' },
	{ value: 'trustee -joint secretary', label: 'Trustee -Joint secretary' },
	{ value: 'trustee -treasrer', label: 'Trustee -Treasrer' },
	{ value: 'trustee -joint treasrer', label: 'Trustee -Joint Treasrer' },
	{ value: 'trustee', label: 'Trustee' },
	{ value: 'executive trustee', label: 'Executive Trustee' },
	{ value: 'chairman', label: 'Chairman' },
	{ value: 'managing director', label: 'Managing director' },
	{ value: 'director', label: 'Director' },
	{ value: 'executive director', label: 'Executive director' },
	{ value: 'nominated director', label: 'Nominated director' },
	{ value: 'sub admin ', label: 'Sub Admin ' },
]

export const facilityCategories = [
	{
		category: 'Venue',
		facilities: [
			'Marriage Hall / Banquet Hall',
			'Open Ground / Wadi',
			'Community Dining Hall / Bhojanshala',
			'Meeting Hall / Seminar Room',
		],
	},
	{
		category: 'Accommodation',
		facilities: ['Dormitory / Guest House / Dharmshala'],
	},
	{
		category: 'Event Setup',
		facilities: ['Stage & Mandap Setup', 'Event Lighting Equipment'],
	},
	{
		category: 'Audio/Visual',
		facilities: [
			'Sound System / PA Setup',
			'Projector & Screen / Event Display Tools',
			'Photo/Video Kit (Camera, Tripod, etc.)',
		],
	},
	{
		category: 'Catering',
		facilities: ['Utensil Bank / Crockery Set', 'Catering Equipment (Gas stove, Bhagona, etc.)'],
	},
	{
		category: 'Education',
		facilities: [
			'School Classroom (for rent during non-hours)',
			'Computer Lab / Digital Classroom',
			'Library / Study Room',
		],
	},
	{
		category: 'Transport',
		facilities: ['Bus / Van (for events or group travel)'],
	},
	{
		category: 'Health',
		facilities: [
			'Ambulance (free or subsidized for emergencies)',
			'Health Check-up Equipment / Mobile Clinic Setup',
		],
	},
	{
		category: 'Utility',
		facilities: ['Water Filter / RO Facility (for refilling)', 'Generator / Power Backup Unit'],
	},
]
